import { DIGITAL_ASSETS_PORTFOLIO_ROUTE } from '@r-client/wallet/util/constants';

import { INavigationData } from './types';

export const getNavigationUs = (hasWallet: boolean): INavigationData[] => [
  {
    navigationEntry: 'Investors',
    showWhatsNewSection: true,
    showSpotlightDeal: true,
    items: [
      {
        name: 'All investors',
        showMobileSearch: true,
        subItems: [
          {
            title: 'Live deals',
            subTitle: 'Investment opportunities',
            href: '/investment-opportunities',
            analyticsLabel: 'primary_market',
          },
          {
            title: 'Buy and sell',
            subTitle: 'Trading',
            href: '/secondary-market',
            analyticsLabel: 'secondary_market',
          },
          {
            title: 'Republic Note',
            subTitle: "Own a piece of Republic's upside",
            href: '/note',
            analyticsLabel: 'republic_note',
            style: {
              rowSpan: 2,
              alignItems: 'flex-start',
            },
          },
        ],
      },
      {
        name: 'Accredited only',
        subItems: [
          {
            title: 'Republic Ventures',
            subTitle: 'Opportunities for accredited investors',
            href: '/ventures',
            analyticsLabel: 'republic_ventures',
          },
        ],
      },
      {
        name: 'Institutional',
        subItems: [
          {
            title: 'Republic Capital',
            subTitle: 'Multi-stage venture firm',
            href: 'https://republic.com/capital',
            analyticsLabel: 'republic_capital',
            style: {
              rowSpan: 2,
              alignItems: 'flex-start',
            },
          },
        ],
      },
      {
        name: 'More',
        subItems: [
          {
            title: 'Wallet',
            subTitle: 'Manage your digital assets',
            href: hasWallet ? DIGITAL_ASSETS_PORTFOLIO_ROUTE : '/wallet',
            analyticsLabel: 'wallet',
          },
          {
            title: 'Mobile app',
            subTitle: 'Available on iOS or Android',
            href: '/app',
            analyticsLabel: 'mobile_app',
          },
          {
            title: 'Learning center',
            subTitle: 'Explore investor resources',
            href: '/learn/investors/how-it-works',
            analyticsLabel: 'learning_center',
          },
        ],
      },
    ],
  },
  {
    navigationEntry: 'Businesses',
    showWhatsNewSection: false,
    showSpotlightDeal: false,
    items: [
      {
        name: 'Growth capital solutions',
        subItems: [
          {
            title: 'Capital fundraising',
            subTitle: 'Raise on Republic',
            href: '/raise',
            analyticsLabel: 'community_fundraising',
          },
          {
            title: 'Tokenized assets',
            subTitle: 'Design, launch, manage tokenized assets',
            href: '/tokenization',
            analyticsLabel: 'tokenized_assets',
          },
          {
            title: 'Sharedrops',
            subTitle: 'Gift equity as a reward',
            href: '/sharedrops',
            analyticsLabel: 'sharedrops',
          },
          {
            title: 'Founder Academy',
            subTitle: 'A complete guide to raising funds',
            href: '/academy',
            analyticsLabel: 'founder_academy',
            isExternal: true,
          },
        ],
      },
      {
        name: 'Web3 services',
        subItems: [
          {
            title: 'Advisory',
            subTitle: 'Access veteran web3 advisors',
            href: 'https://republic.com/advisory',
            analyticsLabel: 'web3_advisory',
          },
          {
            title: 'Infrastructure',
            subTitle: 'Stake your digital assets',
            href: 'https://republic.com/infrastructure',
            analyticsLabel: 'web3_infrastructure',
          },
          {
            title: 'Tokenization',
            subTitle: 'Deploy your assets on-chain',
            href: 'https://republic.com/tokenization',
            analyticsLabel: 'web3_tokenization',
            style: { rowSpan: 2, alignItems: 'flex-start' },
          },
        ],
      },
      {
        name: 'Institutional services',
        subItems: [
          {
            title: 'Republic Capital',
            subTitle: 'In-house Venture Capital fund',
            href: 'https://republic.com/capital',
            analyticsLabel: 'capital_fundraising',
          },
          {
            title: 'Broker-dealer',
            subTitle: 'Regulated capital services',
            href: '/capital-r',
            analyticsLabel: 'broker_dealer',
          },
        ],
      },
    ],
  },
];
